<template>
  <div>
    <main-header-info :navInfoItems="schema.navInfoItems" />
    <v-tab-vertical :legalItems="schema.legalItems" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import VTabVertical from '@/components/base/VTabVertical.vue';

export default {
  name: 'HomePatLegal',
  components: {
    MainHeaderInfo,
    VTabVertical,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('homePatLegalPage', ['schema']),
  },
  methods: {
    ...mapActions('homePatLegalPage', ['loadSchema']),
  },
};
</script>
